// ==================================================
//  メインビジュアルのアニメーション
// ==================================================
window.addEventListener("load", (event) => {
  const jsLoadedAnimationElement = document.querySelector(".mainvisual-js");
  const loadedAnimation = () => {
    jsLoadedAnimationElement.classList.add("mainvisual-js-active");
  };
  setTimeout(loadedAnimation, 1.0 * 600);
});

// ==================================================
//  About スライダー（Slick）
// ==================================================
$(document).ready(function () {
  $(".about_slider-js")
    .not(".slick-initialized")
    .slick({
      autoplay: true,
      autoplaySpeed: 0,
      speed: 10000,
      cssEase: "linear",
      slidesToShow: 2,
      centerMode: true,
      variableWidth: true,
      swipe: false,
      arrows: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      rtl: true, // dir="rtl"
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    });
});
